/**
 * Preset ÚNICO do thumbnail de vídeo, compartilhado entre o card do carrossel
 * (`VideoCard`) e o pôster do feed (`ReelVideoPlayer`).
 *
 * Os dois componentes mostram a MESMA imagem do MESMO imóvel — com
 * modificadores IPX idênticos (format/quality/width/height/sizes), as URLs
 * geradas são idênticas e a entrada do feed pinta o pôster direto do cache
 * HTTP, em vez de re-baixar a imagem que o usuário estava olhando no card um
 * clique atrás. Qualquer divergência de parâmetro quebra o cache hit — se
 * mudar algo aqui, muda para os dois.
 *
 * width/height são teto (~2× o slot no mobile) com ratio 9/14; o seletor
 * responsivo real é `sizes`, alinhado ao basis do carrossel da ShortsSection
 * (94% / 48% / 32% / 24%).
 */
export const REEL_THUMB_SIZES =
	'(max-width: 767px) 94vw, (max-width: 1023px) 48vw, (max-width: 1279px) 32vw, 24vw';
export const REEL_THUMB_WIDTH = 840;

/** CSS width of a carousel card: the same basis as REEL_THUMB_SIZES. */
export function carouselCardCssWidth(viewportWidth: number): number {
	const share =
		viewportWidth <= 767
			? 0.94
			: viewportWidth <= 1023
				? 0.48
				: viewportWidth <= 1279
					? 0.32
					: 0.24;
	return Math.round(viewportWidth * share);
}
export const REEL_THUMB_HEIGHT = Math.round((REEL_THUMB_WIDTH * 14) / 9);
export const REEL_THUMB_FORMAT = 'webp';
export const REEL_THUMB_QUALITY = 85;
